module.exports = __webpack_public_path__ + "static/media/PB-RACE-BLUE-SQ-2.1eeedee5.svg";